/**
 * 导出PDF
 */
export function handleExport(response, fileName) {
  // 获取文件名
  let filename = fileName;
  const contentDisposition = response && response.headers && response.headers['content-disposition'] || fileName;
  if (contentDisposition) {
    filename = getFilenameFromContentDisposition(contentDisposition) || fileName;
  }

  // 创建Blob对象
  const blob = new Blob([response.data], { type: response.headers['content-type'] });

  // 创建下载链接
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename || '分析报告.pdf';
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(blobUrl);
  document.body.removeChild(a);
}

/**
 * 从响应头获取文件名
 */
export function getFilenameFromContentDisposition(header) {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(header);
  if (matches != null && matches[1]) {
    let filename = matches[1].replace(/['"]/g, '');
    // 处理UTF-8编码的文件名
    if (filename.includes('%')) {
      filename = decodeURIComponent(filename);
    }
    return filename;
  }
  return null;
}
